/* eslint-disable */
// @ts-nocheck
import * as Types from '../../types.generated.js';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { customFetcher } from 'libs/data-access/src/lib/custom-fetcher/';
export type SubscribeToTalentNewsletterMutationVariables = Types.Exact<{
  email: Types.Scalars['String'];
}>;


export type SubscribeToTalentNewsletterMutation = { __typename?: 'Mutation', subscribeToTalentNewsletter: boolean };


export const SubscribeToTalentNewsletterDocument = /*#__PURE__*/ `
    mutation SubscribeToTalentNewsletter($email: String!) {
  subscribeToTalentNewsletter(email: $email)
}
    `;
export const useSubscribeToTalentNewsletterMutation = <
      TError = {extensions: {code: string, serviceName: string, exception: Record<string, unknown>}, message: string},
      TContext = unknown
    >(options?: UseMutationOptions<SubscribeToTalentNewsletterMutation, TError, SubscribeToTalentNewsletterMutationVariables, TContext>) =>
    useMutation<SubscribeToTalentNewsletterMutation, TError, SubscribeToTalentNewsletterMutationVariables, TContext>(
      ['SubscribeToTalentNewsletter'],
      (variables?: SubscribeToTalentNewsletterMutationVariables) => customFetcher<SubscribeToTalentNewsletterMutation, SubscribeToTalentNewsletterMutationVariables>(SubscribeToTalentNewsletterDocument, variables)(),
      options
    );
useSubscribeToTalentNewsletterMutation.getKey = () => ['SubscribeToTalentNewsletter'];

useSubscribeToTalentNewsletterMutation.fetcher = (variables: SubscribeToTalentNewsletterMutationVariables, options?: RequestInit['headers']) => customFetcher<SubscribeToTalentNewsletterMutation, SubscribeToTalentNewsletterMutationVariables>(SubscribeToTalentNewsletterDocument, variables, options);